if(!customElements.get('predictive-search')) {

  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
      this.predictiveClearButtonMobile = this.querySelector('[data-clear-button]');
      this.predictiveSearchResults = this.querySelector('.predictive-search');
      this.predictiveSearchResources = this.predictiveSearchResults.getAttribute('data-resources-types') || 'product';
      this.predictiveSearchMaxSize = this.predictiveSearchResults.getAttribute('data-max-results') || 4;

      // this will be used to hide the complementary menus when the Search is open
      this.menuDrawer = this.closest('[data-menu-drawer]');

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 100).bind(this));

      // clear search mobile field on mobile on button clear click 
      this.predictiveClearButtonMobile?.addEventListener('click', () => {
        this.clearInput();
      });
    }

    onChange() {
      const searchTerm = this.input.value.trim();
      if (!searchTerm.length) {
        this.close();
        this.predictiveClearButtonMobile?.classList.add('hidden');
        this.menuDrawer?.classList.remove('menu-drawer--hide-complementary-menus');
        return;
      }
      this.getSearchResults(searchTerm);
      this.predictiveClearButtonMobile?.classList.remove('hidden');
      this.menuDrawer?.classList.add('menu-drawer--hide-complementary-menus');
    }

    /**
     * getSearchResults
     * @param {String} searchTerm 
     * @description https://shopify.dev/api/ajax/reference/predictive-search
     */
    getSearchResults(searchTerm) {
      fetch(`${routes.predictive_search_url}?q=${searchTerm}&resources[type]=${this.predictiveSearchResources}&resources[limit]=${this.predictiveSearchMaxSize}&section_id=predictive-search`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
          this.predictiveSearchResults.innerHTML = resultsMarkup;
          this.open();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    }

    open() {
      this.predictiveSearchResults.classList.remove('hidden');
    }

    close() {
      this.predictiveSearchResults.classList.add('hidden');
    }

    clearInput() {
      this.input.value = '';
      this.onChange();
      this.predictiveClearButtonMobile?.classList.add('hidden');
      this.menuDrawer?.classList.remove('menu-drawer--hide-complementary-menus');
    }
  }

  window.PredictiveSearch = PredictiveSearch;

  customElements.define('predictive-search', PredictiveSearch);

}